"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestRoutings = void 0;
const common_1 = require("@finley-technologies/common");
const extractCreditAgreementBankAccountIds = (linkedAccountContainer) => {
    const contents = linkedAccountContainer?.contents ?? [];
    const accountIds = contents.map((content) => content.value);
    return accountIds;
};
const getRoutings = ({ type, bankAccounts, source, destination, }) => {
    const sourceCase = source.multiple
        ? {
            condition: source.ids.length >= 1,
            errorText: `${type} must have at least 1 registered bank account ID within source accounts, but found ${source.ids.length}`,
        }
        : {
            condition: source.ids.length === 1,
            errorText: `${type} must have only 1 registered bank account ID within source accounts, but found ${source.ids.length}`,
        };
    const destinationCase = destination.multiple
        ? {
            condition: destination.ids.length >= 1,
            errorText: `${type} must have at least 1 registered bank account ID within destination accounts, but found ${destination.ids.length}`,
        }
        : {
            condition: destination.ids.length === 1,
            errorText: `${type} must have only 1 registered bank account ID within destination accounts, but found ${destination.ids.length}`,
        };
    (0, common_1.finleyAssert)(sourceCase.condition, sourceCase.errorText);
    (0, common_1.finleyAssert)(destinationCase.condition, destinationCase.errorText);
    const requestRoutings = [];
    for (const sourceBankAccountId of source.ids) {
        const sourceBankAccount = bankAccounts.find((bankAccount) => bankAccount.entity.id === sourceBankAccountId);
        (0, common_1.finleyAssert)(sourceBankAccount, `Source bank account was not found in credit agreement for ${type} routing using bank account ID: ${sourceBankAccountId}`);
        for (const destinationBankAccountId of destination.ids) {
            const destinationBankAccount = bankAccounts.find((bankAccount) => bankAccount.entity.id === destinationBankAccountId);
            (0, common_1.finleyAssert)(destinationBankAccount, `Destination bank account was not found in credit agreement for ${type} routing using bank account ID: ${destinationBankAccountId}`);
            requestRoutings.push({
                type,
                source: {
                    accountId: sourceBankAccount.entity.id,
                    accountName: `${sourceBankAccount.entity.name} (${sourceBankAccount.entity.accountNumber})`,
                    accountType: sourceBankAccount.type.value,
                    organizationId: sourceBankAccount.entity.organizationId,
                },
                destination: {
                    accountId: destinationBankAccount.entity.id,
                    accountName: `${destinationBankAccount.entity.name} (${destinationBankAccount.entity.accountNumber})`,
                    accountType: destinationBankAccount.type.value,
                    organizationId: destinationBankAccount.entity.organizationId,
                },
            });
        }
    }
    return requestRoutings;
};
const getRequestRoutings = ({ parties, fundingRequestMechanics, }) => {
    const bankAccounts = [];
    for (const party of parties) {
        bankAccounts.push(...party.bankAccounts);
    }
    const routings = new Map([
        [
            'collectionsPaydown',
            {
                source: {
                    ids: extractCreditAgreementBankAccountIds(fundingRequestMechanics.collectionsPaydown.sourceAccounts),
                    multiple: true,
                },
                destination: {
                    ids: extractCreditAgreementBankAccountIds(fundingRequestMechanics.collectionsPaydown.destinationAccounts),
                    multiple: true,
                },
            },
        ],
        [
            'collectionsRecycle',
            {
                source: {
                    ids: extractCreditAgreementBankAccountIds(fundingRequestMechanics.collectionsRecycle.sourceAccounts),
                    multiple: true,
                },
                destination: {
                    ids: extractCreditAgreementBankAccountIds(fundingRequestMechanics.collectionsRecycle.destinationAccounts),
                    multiple: false,
                },
            },
        ],
        [
            'curePaydown',
            {
                source: {
                    ids: extractCreditAgreementBankAccountIds(fundingRequestMechanics.curePaydown.sourceAccounts),
                    multiple: false,
                },
                destination: {
                    ids: extractCreditAgreementBankAccountIds(fundingRequestMechanics.curePaydown.destinationAccounts),
                    multiple: true,
                },
            },
        ],
        [
            'drawRequest',
            {
                source: {
                    ids: extractCreditAgreementBankAccountIds(fundingRequestMechanics.drawRequest.sourceAccounts),
                    multiple: true,
                },
                destination: {
                    ids: extractCreditAgreementBankAccountIds(fundingRequestMechanics.drawRequest.destinationAccounts),
                    multiple: false,
                },
            },
        ],
    ]);
    const requestRoutings = [];
    for (const [type, config] of routings.entries()) {
        const results = getRoutings({
            type,
            bankAccounts,
            source: { ids: config.source.ids, multiple: config.source.multiple },
            destination: {
                ids: config.destination.ids,
                multiple: config.destination.multiple,
            },
        });
        requestRoutings.push(...results);
    }
    return requestRoutings;
};
exports.getRequestRoutings = getRequestRoutings;
//# sourceMappingURL=routing.js.map